var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "letter-page" }, [
    _c("div", { staticClass: "letter-card" }, [
      _c("header", { staticClass: "letter-head" }, [
        _c("div", { staticClass: "head-orn" }, [_vm._v("✿")]),
        _c("h1", { staticClass: "letter-title" }, [_vm._v(_vm._s(_vm.title))]),
        _vm.date
          ? _c("div", { staticClass: "letter-date" }, [
              _vm._v(_vm._s(_vm.date)),
            ])
          : _vm._e(),
      ]),
      _c(
        "div",
        { staticClass: "letter-body" },
        _vm._l(_vm.paragraphs, function (p, i) {
          return _c(
            "p",
            {
              key: i,
              staticClass: "letter-p",
              style: { animationDelay: 0.15 + i * 0.12 + "s" },
            },
            [_vm._v(_vm._s(p))]
          )
        }),
        0
      ),
      _vm._m(0),
      _c("footer", { staticClass: "letter-sign" }, [
        _c("span", { staticClass: "sign-name" }, [_vm._v(_vm._s(_vm.sign))]),
        _vm.signDate
          ? _c("span", { staticClass: "sign-date" }, [
              _vm._v("——" + _vm._s(_vm.signDate)),
            ])
          : _vm._e(),
      ]),
    ]),
    _vm.showBack
      ? _c("div", { staticClass: "letter-back", on: { click: _vm.goBack } }, [
          _c("span", { staticClass: "back-ico" }, [_vm._v("‹")]),
          _vm._v(" 返回列表 "),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "letter-divider" }, [
      _c("span", [_vm._v("❦")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }